// React imports
import React, { useState, useRef, useEffect } from 'react';
import store from './redux/store';
import { Provider, useDispatch, useSelector } from 'react-redux';

// Component imports
import DetectDevice from './DeviceDetector';
import Info_intro from './Info_intro.js';
import Info_pricing from './Info_pricing.js';
import Info_nav from './Info_nav.js';
import Info_minting from './Info_minting.js';
import Info_explainers from './Info_explainers.js';
import Info_about from './Info_about.js';
import Info_art_tech from './Info_art_tech.js';
import Info_contact from './Info_contact.js';
import Info_pckg from './Info_pckg.js';
import Info_claim from './Info_claim.js';
import Info_TPX_store from './Info_TPX_store.js';

// Library imports
import { useMap } from 'react-leaflet/hooks';

// Icons
import { IoIosClose, IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';

// Style imports
import '../styles/information.css';
import '../styles/listview.css';

export const Information = ({
  setProjectInfo,
  setSidebar,
  masterTile,
  currentPrompt,
  gridOverlay,
  setMasterTile,
  setSidebarTitle,
  ownershipUpdated,
  setCurrentPrompt,
  setTilePreview,
  listViewExpanded,
  setlistViewExpanded,
  redactNFTs,
  mintMessage,
  setMintMessage,
  setRevertMessage,
  ownership,
  setOwnership,
  currFetchingItems,
  setCurrFetchingItems, 
}) => {
  const map = useMap();

  // This determines the order of the slides
  // Use ' ' to add a break
  const slides = [
    'intro',
    'explainers',
    ...(!DetectDevice ? [' '] : []),
    'art_tech',
    'nav',
    ...(!DetectDevice ? [' '] : []),
    ...(!redactNFTs ? ['minting'] : []), // spread operator; only include pricing if on desktop
    ...(!DetectDevice && !redactNFTs ? ['pricing'] : []), // spread operator; only include pricing if on desktop
    ...(!redactNFTs ? ['pckg'] : []), // spread operator; only include pricing if on desktop
    ...(!redactNFTs ? ['TPX'] : []),
    //...(!DetectDevice && !redactNFTs ? ['redactedWindow'] : []),
    ...(!DetectDevice ? [' '] : []),
    'about',
    // 'contact',
  ];

  // Useful for name remapping
  const slides_dict = {
    intro: 'intro',
    nav: 'navigation',
    minting: 'minting',
    art_tech: 'art & tech',
    about: 'about us',
    contact: 'contact',
    pricing: 'pricing',
    pckg: 'pckg',
    explainers: 'explainers',
    blank: ' ',
    TPX: 'TPX',
    //redactedWindow: 'redactedWindow'
  };

  const [currentTab, setCurrentTab] = useState(null ?? slides[0]);
  const [currentSlide, setCurrentSlide] = useState(0);

  var totalSlides = slides.length;

  // E.g, if have info.nav in URL, set currentTab to nav
  const handleTabInURL = () => {
    let currentUrl = window.location.href;
    let tileUrl = currentUrl.split('/');
    if (tileUrl[tileUrl.length - 1] === '') {
      tileUrl.pop();
    }
    if (tileUrl[tileUrl.length - 2] === 'todem') {
      let input = tileUrl[tileUrl.length - 1];
      let parts = input.split('.');
      console.log(slides.indexOf(parts[1]));
      if (slides.indexOf(parts[1]) != -1) {
        setCurrentTab(parts[1]);
        setCurrentSlide(slides.indexOf(parts[1]));
      }
    }
  };

  // On initial load
  useEffect(() => {
    handleTabInURL();
    map.smoothWheelZoom.disable();
    map.dragging.disable();

    return () => {
      var urlId = '/todem/';
      window.history.pushState('', '', '' + urlId);
      let tileNum = masterTile.masterTile.name;
      if (!isNaN(Number(tileNum.split('-')[1]))) {
        urlId += tileNum.split('-')[1].padStart(4, '0');
        if (currentPrompt) {
          urlId += '.' + currentPrompt[0];
        }
        window.history.pushState('', '', '' + urlId);
      }
    };
  }, []);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Change the ref value to false after first render
      return;
    }
    var urlId = '/todem/info.' + currentTab;
    window.history.pushState('', '', '' + urlId);
  }, [currentTab]);

  useEffect(() => {
    if (currentSlide >= totalSlides) {
      setCurrentSlide(0);
      return;
    }
    if (currentSlide < 0) {
      setCurrentSlide(totalSlides - 1);
      return;
    }
    setCurrentTab(slides[currentSlide]);
  }, [currentSlide]);

  useEffect(() => {
    if (listViewExpanded == 1) {
      setCurrentTab('pricing');
    }
    if (listViewExpanded == 2) {
      setCurrentTab('TPX');
      setProjectInfo(2);
    }
  }, [listViewExpanded]);

  return (
    <div
      className="information"
      onLoad={() => {
        if (DetectDevice) {
          setSidebar(0);
        }
      }}
    >
      <div className="info-pop">
        <div
          className="info-close"
          onClick={() => {
            var information = document.getElementsByClassName('information')[0];
            information.style.animation = 'fadeInfoOut 0.35s';
            map.smoothWheelZoom.enable();
            map.dragging.enable();
            let playbox = document.getElementsByClassName(
              'bttn frame-controller'
            )[0];

            setTimeout(() => {
              setProjectInfo(0);
              setlistViewExpanded(0);
            }, 340);
            setTimeout(() => {
              playbox.style.visibility = 'visible';
            }, 100);
          }}
        >
          <IoIosClose
            className="icon"
            style={DetectDevice ? { fontSize: 45 } : { fontSize: 35 }}
          />
        </div>

        <div id={currentTab !== 'redactedWindow' ? "info-grid-container-container3" : "info-grid-container-container4"}>
          {currentTab !== 'redactedWindow' ? (
            <>
              {DetectDevice ? (
                <div className="info-grid-container2">
                  <div id="mobile-category">
                    <table style={{ marginLeft: "5%", width: "80%" }}>
                      <tr>
                        <td style={{ width: "33%", textAlign: "center" }}><div
                          className="info-last-button"
                          onClick={() => {
                            setCurrentSlide(currentSlide - 1);
                          }}
                        >
                          <IoIosArrowBack className="icon" style={{ fontSize: 24 }} />
                        </div></td>
                        <td style={{ width: "33%", textAlign: "center" }}><div className="sub-cat" style={{ fontSize: 16 }}>{slides_dict[currentTab]}</div></td>
                        <td style={{ width: "33%", textAlign: "center" }}><div
                          className="info-next-button"
                          onClick={() => {
                            setCurrentSlide(currentSlide + 1);
                          }}
                        >
                          <IoIosArrowForward
                            style={{ fontSize: 24 }}
                            className="icon"
                          />
                        </div></td>
                      </tr>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="info-grid-container2">
                  {slides.map((slide, i) => (
                    slide == ' ' ?
                      (
                        <br/>
                      ) : (
                        <div
                          className={
                            currentTab === slide
                              ? 'info-category selected-cat'
                              : 'info-category'
                          }
                          key={i}
                          onClick={() => {
                            setCurrentTab(slide);
                          }}
                        >
                          <div className="sub-cat">{slides_dict[slide]}</div>
                        </div>
                      )

                  ))}
                </div>
              )}
            </>
          ) : null}

          <div
            style={{
              height: currentTab == 'redactedWindow' ? "100%" : null,
              width: currentTab == 'redactedWindow' ? "100%" : null,
            }}>
            <div id="info-synopsis"
              style={{
                height: currentTab == 'redactedWindow' ? "96%" : null,
                width: currentTab == 'redactedWindow' ? "98%" : null,
                margin: currentTab == 'redactedWindow' ? "1%" : null,
                overflowY: DetectDevice ? 'scroll' : null,
              }}>
              <>
                {(() => {
                  switch (currentTab) {
                    case 'intro':
                      return <Info_intro redactNFTs={redactNFTs} />;
                    case 'nav':
                      return <Info_nav />;
                    case 'pricing':
                      return (
                        <Info_pricing
                          setProjectInfo={setProjectInfo}
                          setSidebar={setSidebar}
                          masterTile={masterTile}
                          currentPrompt={currentPrompt}
                          gridOverlay={gridOverlay}
                          setMasterTile={setMasterTile}
                          setSidebarTitle={setSidebarTitle}
                          ownershipUpdated={ownershipUpdated}
                          setCurrentPrompt={setCurrentPrompt}
                          setTilePreview={setTilePreview}
                          listViewExpanded={listViewExpanded}
                          setlistViewExpanded={setlistViewExpanded}
                          ownership={ownership}
                          setOwnership={setOwnership}
                        />
                      );
                    case 'minting':
                      return <Info_minting />;
                    case 'explainers':
                      return <Info_explainers />;
                    case 'about':
                      return <Info_about />;
                    case 'contact':
                      return <Info_contact />;
                    case 'art_tech':
                      return <Info_art_tech DetectDevice={DetectDevice}/>;
                    case 'pckg':
                      return <Info_pckg />;
                    case 'TPX':
                      return <Info_claim
                        setProjectInfo={setProjectInfo}
                        setSidebar={setSidebar}
                        masterTile={masterTile}
                        currentPrompt={currentPrompt}
                        gridOverlay={gridOverlay}
                        setMasterTile={setMasterTile}
                        setSidebarTitle={setSidebarTitle}
                        ownershipUpdated={ownershipUpdated}
                        setCurrentPrompt={setCurrentPrompt}
                        setTilePreview={setTilePreview}
                        listViewExpanded={listViewExpanded}
                        setlistViewExpanded={setlistViewExpanded}
                        mintMessage={mintMessage}
                        setMintMessage={setMintMessage}
                        setRevertMessage={setRevertMessage}
                        ownership={ownership}
                        setOwnership={setOwnership}
                        DetectDevice={DetectDevice}
                        currFetchingItems={currFetchingItems}
                        setCurrFetchingItems={setCurrFetchingItems} 
                      />;
                    case 'redactedWindow':
                      setProjectInfo(2);
                      return <Info_TPX_store
                        setProjectInfo={setProjectInfo}
                        mintMessage={mintMessage}
                        setMintMessage={setMintMessage}
                        setRevertMessage={setRevertMessage}
                        DetectDevice={DetectDevice}
                      />;

                    default:
                      return <> There was a problem loading this page</>;
                  }
                })()}
              </>
            </div>
          </div>
        </div>
        {!DetectDevice && !redactNFTs && currentTab !== 'redactedWindow' ? (
          <div style={{ display: "flex" }}>
            <a
              style={{
                position: 'absolute',
                bottom: '0',
                right: '0px',
                fontSize: '1em',
                color: 'white',
                textDecoration: 'none',
                marginBottom: '7.5px',
                display: "inline-block"
              }}
              href="https://www.latentculture.com/todem/TODEM-License_Agreement.pdf"
              rel="noreferrer"
              target="_blank"
              id="license"
            >
              {' '}
              NFT License Agreement |
            </a>
            <a
              style={{
                position: 'absolute',
                bottom: '0',
                left: '88px',
                fontSize: '1em',
                color: 'white',
                textDecoration: 'none',
                marginBottom: '7.5px',
                display: "inline-block"
              }}
              href="https://etherscan.io/address/0xe4ebab52aad527c5ee51f218bf10109f4145524c"
              rel="noreferrer"
              target="_blank"
              id="license"
            >
              {' '}
              TODEM Contract
            </a>
          </div>
        ) : null}
      </div>
    </div >
  );
};

export default Information;
